import { lazy } from 'react';

export const LazyIntegrationCreateOneTimeDocPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-create-one-time-doc-page" */ './integration-create-one-time-doc-page'
    ),
);
